var map = {
	"./CanvasClear": 45,
	"./CanvasClear.js": 45,
	"./CanvasMove": 46,
	"./CanvasMove.js": 46,
	"./CommandAbstract": 22,
	"./CommandAbstract.js": 22,
	"./ComponentDelete": 47,
	"./ComponentDelete.js": 47,
	"./ComponentDrag": 48,
	"./ComponentDrag.js": 48,
	"./ComponentEnter": 49,
	"./ComponentEnter.js": 49,
	"./ComponentExit": 50,
	"./ComponentExit.js": 50,
	"./ComponentNext": 51,
	"./ComponentNext.js": 51,
	"./ComponentPrev": 52,
	"./ComponentPrev.js": 52,
	"./ComponentStyleClear": 53,
	"./ComponentStyleClear.js": 53,
	"./CopyComponent": 54,
	"./CopyComponent.js": 54,
	"./DeleteComponent": 55,
	"./DeleteComponent.js": 55,
	"./ExportTemplate": 56,
	"./ExportTemplate.js": 56,
	"./Fullscreen": 57,
	"./Fullscreen.js": 57,
	"./MoveComponent": 58,
	"./MoveComponent.js": 58,
	"./OpenAssets": 59,
	"./OpenAssets.js": 59,
	"./OpenBlocks": 60,
	"./OpenBlocks.js": 60,
	"./OpenLayers": 61,
	"./OpenLayers.js": 61,
	"./OpenStyleManager": 62,
	"./OpenStyleManager.js": 62,
	"./OpenTraitManager": 63,
	"./OpenTraitManager.js": 63,
	"./PasteComponent": 64,
	"./PasteComponent.js": 64,
	"./Preview": 65,
	"./Preview.js": 65,
	"./Resize": 66,
	"./Resize.js": 66,
	"./SelectComponent": 14,
	"./SelectComponent.js": 14,
	"./SelectPosition": 27,
	"./SelectPosition.js": 27,
	"./ShowOffset": 67,
	"./ShowOffset.js": 67,
	"./SwitchVisibility": 68,
	"./SwitchVisibility.js": 68
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;


// WEBPACK FOOTER //
// webpack:/grapesjs/src/commands/view sync ^/.//.*$